module.exports = __webpack_public_path__ + "img/bg_数据中心.21afbe02.png";